import { computed, resolveComponent, openBlock, createBlock, withCtx, createElementVNode, createVNode, unref, renderSlot } from "vue";
import { DtInput, DtCheckbox } from "@dialpad/dialtone-vue";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
const _hoisted_1 = { class: "d-fl-grow1" };
const _hoisted_2 = { class: "d-input__label-text d-label--sm" };
const _hoisted_3 = { class: "d-pl6" };
const __default__ = {
  name: "DtcControlNumber"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: Number,
      default: () => Number()
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const props = __props;
    function isNaN(value) {
      return Number.isNaN(value);
    }
    const inputValue = computed(() => {
      return isNaN(props.value) ? null : props.value;
    });
    function toggleNaN(e) {
      emit(VALUE_UPDATE_EVENT, e ? NaN : 0);
    }
    const emit = __emit;
    return (_ctx, _cache) => {
      const _component_dt_stack = resolveComponent("dt-stack");
      return openBlock(), createBlock(_component_dt_stack, {
        direction: "row",
        align: "end"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            createVNode(unref(DtInput), {
              value: inputValue.value,
              disabled: __props.disabled || isNaN(__props.value),
              type: "number",
              size: "sm",
              onInput: _cache[0] || (_cache[0] = (e) => emit(unref(VALUE_UPDATE_EVENT), parseInt(e)))
            }, {
              labelSlot: withCtx(() => [
                createElementVNode("span", _hoisted_2, [
                  renderSlot(_ctx.$slots, "default")
                ])
              ]),
              _: 3
            }, 8, ["value", "disabled"])
          ]),
          createElementVNode("div", _hoisted_3, [
            createVNode(unref(DtCheckbox), {
              label: "NaN",
              checked: isNaN(__props.value),
              disabled: __props.disabled,
              onInput: toggleNaN
            }, null, 8, ["checked", "disabled"])
          ])
        ]),
        _: 3
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_number.vue.js.map
